import { useValueDialog } from '../../../../hooks/useDialog';

type Value = { itemId: string; initialValue: string };

export const useCreateOrUpdateDialog = () => useValueDialog<Value | null>();
